export const REVIEW_SECTION_GIFT_CARD = "Gift Card";
export const REVIEW_SECTION_OTHER = "Other";
export const REVIEW_OUTCOME_LOST = "Lost";

export const REVIEW_TYPE_OPTIONS = Object.freeze([
  { value: "New", labelKey: "customerSession.options.type.New" },
  { value: "Returning", labelKey: "customerSession.options.type.Returning" },
]);

export const REVIEW_SECTION_OPTIONS = Object.freeze([
  { value: "Boost", labelKey: "customerSession.options.section.Boost" },
  { value: "Currency", labelKey: "customerSession.options.section.Currency" },
  { value: "Account", labelKey: "customerSession.options.section.Account" },
  { value: "Item", labelKey: "customerSession.options.section.Item" },
  { value: "Gift Card", labelKey: "customerSession.options.section.Gift Card" },
  { value: "Other", labelKey: "customerSession.options.section.Other" },
]);

export const REVIEW_REQUEST_OPTIONS = Object.freeze([
  {
    value: "Price inquiry",
    labelKey: "customerSession.options.request.Price inquiry",
  },
  { value: "New order", labelKey: "customerSession.options.request.New order" },
  {
    value: "Order status",
    labelKey: "customerSession.options.request.Order status",
  },
  { value: "Complaint", labelKey: "customerSession.options.request.Complaint" },
  { value: "Refund", labelKey: "customerSession.options.request.Refund" },
  { value: "Other", labelKey: "customerSession.options.request.Other" },
]);

export const REVIEW_OUTCOME_OPTIONS = Object.freeze([
  { value: "Sold", labelKey: "customerSession.options.outcome.Sold" },
  { value: "Lost", labelKey: "customerSession.options.outcome.Lost" },
  { value: "Ongoing", labelKey: "customerSession.options.outcome.Ongoing" },
  {
    value: "Support only",
    labelKey: "customerSession.options.outcome.Support only",
  },
  { value: "Refunded", labelKey: "customerSession.options.outcome.Refunded" },
]);

export const REVIEW_LOSS_REASON_OPTIONS = Object.freeze([
  { value: "Price", labelKey: "customerSession.options.lossReason.Price" },
  {
    value: "No availability",
    labelKey: "customerSession.options.lossReason.No availability",
  },
  {
    value: "Too slow",
    labelKey: "customerSession.options.lossReason.Too slow",
  },
  {
    value: "Client stopped replying",
    labelKey: "customerSession.options.lossReason.Client stopped replying",
  },
  { value: "Trust", labelKey: "customerSession.options.lossReason.Trust" },
  {
    value: "No Followup",
    labelKey: "customerSession.options.lossReason.No Followup",
  },
  { value: "Other", labelKey: "customerSession.options.lossReason.Other" },
]);

export const REVIEW_COMPLAINT_REASON_OPTIONS = Object.freeze([
  { value: "Delay", labelKey: "customerSession.options.complaintReason.Delay" },
  {
    value: "Wrong info",
    labelKey: "customerSession.options.complaintReason.Wrong info",
  },
  { value: "Rude", labelKey: "customerSession.options.complaintReason.Rude" },
  {
    value: "Order problem",
    labelKey: "customerSession.options.complaintReason.Order problem",
  },
  { value: "Other", labelKey: "customerSession.options.complaintReason.Other" },
]);

const SECTION_CONFIG_SERVICE = Object.freeze({
  Boost: "Boost",
  Currency: "Currency",
  Item: "Currency",
  Account: "Account",
});

export function configServiceForSection(section) {
  return SECTION_CONFIG_SERVICE[section] ?? null;
}
